// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overview__wrapper__omdEk","closeLink":"overview__closeLink__1Ugcd"};